import polyfillContains from '../common/polyfills/Node/prototype/contains';
import 'whatwg-fetch';
import 'jspolyfill-array.prototype.findIndex';
import 'jspolyfill-array.prototype.find';
import { PermissionCoreApp } from './app/permission-core-app';
import * as Logger from '../common/tools/logger';
import { initSentry, sentryAppender } from '../common/tools/sentry';
import {
  CONFIG_SENTRY_DSN_DEFAULT,
  CONFIG_SENTRY_DSN_IOS,
  CONFIG_SENTRY_DSN_ANDROID
} from '../config';

/* istanbul ignore next else */
if (window.name) {
  let sentryDsn = CONFIG_SENTRY_DSN_DEFAULT,
      sentryDetailed = false;

  if (window.name.toLowerCase() === 'app_and/permission' && CONFIG_SENTRY_DSN_ANDROID.length > 0) {
    sentryDsn = CONFIG_SENTRY_DSN_ANDROID;
    sentryDetailed = true;
  } else if (window.name.toLowerCase() === 'app_ios/permission' && CONFIG_SENTRY_DSN_IOS.length > 0) {
    sentryDsn = CONFIG_SENTRY_DSN_IOS;
    sentryDetailed = true;
  }

  initSentry(sentryDsn, sentryDetailed);
  Logger.registerAppender(sentryAppender);
} else {
  if (CONFIG_SENTRY_DSN_DEFAULT.length > 0) {
    initSentry(CONFIG_SENTRY_DSN_DEFAULT, false);
    Logger.registerAppender(sentryAppender);
  }
}

polyfillContains();

export default new PermissionCoreApp();
